export default __webpack_public_path__ + "src/images/galleries/1/info_cn-e5f6ed.png";